/**
 * Get the longest key match from the given path keys.
 */
export const getLongestPathKeyMatch = (allPathKeys: string[], allAppKeys: string[]) => {
  const appKeysSet = new Set(allAppKeys);
  let longestMatch = '';
  let longestLength = -1;

  for (const key of allPathKeys) {
    if (appKeysSet.has(key) && key.length > longestLength) {
      longestLength = key.length;
      longestMatch = key;
    }
  }

  return longestMatch !== '' ? [longestMatch] : allPathKeys;
};
